// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from "./client";
import type {
	RemoveFromBasketData,
	RemoveFromBasketResponses,
	RemoveFromBasketErrors,
	AddToBasketData,
	AddToBasketResponses,
	AddToBasketErrors,
	GetBasketData,
	GetBasketResponses,
	GetBasketErrors,
	UpdateBasketItemData,
	UpdateBasketItemResponses,
	UpdateBasketItemErrors,
	AddToCartData,
	AddToCartResponses,
	AddToCartErrors,
	CreateData,
	CreateResponses,
	CreateErrors,
	ResetPasswordData,
	ResetPasswordResponses,
	ResetPasswordErrors,
	SendPasswordResetMailData,
	SendPasswordResetMailResponses,
	SendPasswordResetMailErrors,
	SearchData,
	SearchResponses,
	GetTranslationKeysData,
	GetTranslationKeysResponses,
	GetTranslationKeysErrors,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
	TData,
	ThrowOnError
> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

export class BasketService {
	public static removeFromBasket<ThrowOnError extends boolean = false>(
		options?: Options<RemoveFromBasketData, ThrowOnError>
	) {
		return (options?.client ?? _heyApiClient).delete<RemoveFromBasketResponses, RemoveFromBasketErrors, ThrowOnError>({
			url: "/_esfn/api/Basket",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static addToBasket<ThrowOnError extends boolean = false>(options?: Options<AddToBasketData, ThrowOnError>) {
		return (options?.client ?? _heyApiClient).post<AddToBasketResponses, AddToBasketErrors, ThrowOnError>({
			url: "/_esfn/api/Basket/add",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static getBasket<ThrowOnError extends boolean = false>(options?: Options<GetBasketData, ThrowOnError>) {
		return (options?.client ?? _heyApiClient).get<GetBasketResponses, GetBasketErrors, ThrowOnError>({
			url: "/_esfn/api/Basket/getBasket",
			...options,
		});
	}

	public static updateBasketItem<ThrowOnError extends boolean = false>(
		options?: Options<UpdateBasketItemData, ThrowOnError>
	) {
		return (options?.client ?? _heyApiClient).post<UpdateBasketItemResponses, UpdateBasketItemErrors, ThrowOnError>({
			url: "/_esfn/api/Basket/update",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class GoogleService {
	public static addToCart<ThrowOnError extends boolean = false>(options?: Options<AddToCartData, ThrowOnError>) {
		return (options?.client ?? _heyApiClient).post<AddToCartResponses, AddToCartErrors, ThrowOnError>({
			url: "/_esfn/api/GoogleTracking",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class OrderService {
	public static create<ThrowOnError extends boolean = false>(options?: Options<CreateData, ThrowOnError>) {
		return (options?.client ?? _heyApiClient).post<CreateResponses, CreateErrors, ThrowOnError>({
			url: "/_esfn/api/Order",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class PasswordResetService {
	public static resetPassword<ThrowOnError extends boolean = false>(
		options?: Options<ResetPasswordData, ThrowOnError>
	) {
		return (options?.client ?? _heyApiClient).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
			url: "/_esfn/api/PasswordReset/resetpassword",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	public static sendPasswordResetMail<ThrowOnError extends boolean = false>(
		options?: Options<SendPasswordResetMailData, ThrowOnError>
	) {
		return (options?.client ?? _heyApiClient).post<
			SendPasswordResetMailResponses,
			SendPasswordResetMailErrors,
			ThrowOnError
		>({
			url: "/_esfn/api/PasswordReset/sendpasswordresetmail",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class QuickSearchService {
	public static search<ThrowOnError extends boolean = false>(options?: Options<SearchData, ThrowOnError>) {
		return (options?.client ?? _heyApiClient).get<SearchResponses, unknown, ThrowOnError>({
			url: "/_esfn/api/QuickSearch",
			...options,
		});
	}
}

export class TranslationsService {
	public static getTranslationKeys<ThrowOnError extends boolean = false>(
		options?: Options<GetTranslationKeysData, ThrowOnError>
	) {
		return (options?.client ?? _heyApiClient).get<GetTranslationKeysResponses, GetTranslationKeysErrors, ThrowOnError>({
			url: "/_esfn/api/Translations/keys",
			...options,
		});
	}
}
